/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connection: NonNullable<unknown> }} Audit_Details_Tool_Connection_Linked_DescInputs */



/**
* | output |
* | --- |
* | "Tool connection linked: {connection}. Its tools became available in that project, and its content readable by the project's members." |
*
* @param {Audit_Details_Tool_Connection_Linked_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_tool_connection_linked_desc = /** @type {((inputs: Audit_Details_Tool_Connection_Linked_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Tool_Connection_Linked_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tool-Verbindung verknüpft: ${i?.connection}. Ihre Tools sind in diesem Projekt nun verfügbar und ihre Inhalte für die Projektmitglieder lesbar.`)
	return /** @type {LocalizedString} */ (`Tool connection linked: ${i?.connection}. Its tools became available in that project, and its content readable by the project's members.`)
});